import Tutorial from 'src/components/Tutorial'
import SimpleLayout from 'src/layouts/SimpleLayout'

const DESCRIPTIONS = [
  undefined,
  undefined,
  'Select "Add to Home Screen"',
  'Open the "Share" menu in the middle of the bottom bar',
  "Install Lahilo as an 'app' by adding a bookmark to your phone homescreen\nSwipe left for iPhone instructions or right for Android",
  'Open the browser menu in the top right and select "Add to Home Screen"',
  undefined,
  undefined,
  undefined,
]

const InstallAppTutorial = () => (
  <SimpleLayout simple>
    <Tutorial
      numPages={9}
      startPage={5}
      descriptions={DESCRIPTIONS}
      tutorialId="install-app"
    />
  </SimpleLayout>
)

export default InstallAppTutorial
